import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup ,Validators} from '@angular/forms';
import { MAT_DIALOG_DATA , MatDialogRef} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApplicationMasterService } from 'src/app/core/services/applicationMaster/application-master.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';

@Component({
  selector: 'app-two-factor-pop-up',
  templateUrl: './two-factor-pop-up.component.html',
  styleUrls: ['./two-factor-pop-up.component.scss']
})
export class TwoFactorPopUpComponent {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  loginForm:FormGroup
  @Output() onSuccess = new EventEmitter<void>();
  @Input() showTwofactor: boolean = false;
  constructor(
    @Optional() public dialogRef: MatDialogRef<TwoFactorPopUpComponent>,
    public formBuilder: FormBuilder,
    private _appMasterService: ApplicationMasterService,
    private _loaderService: LoaderService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private router :Router
) { }
  
ngOnInit(): void {
  this.createLoginForm();
}
  private createLoginForm(): void {
    this.loginForm = this.formBuilder.group({
        twoFactorAuthCode: [null, Validators.required],
    });
  }
  public get f() {
    return this.loginForm.controls;
  }
  public showFieldError(field: AbstractControl): boolean {
    return field.invalid && (field.dirty || field.touched);
  }
  submit() {
    if(this.loginForm.invalid){
      return
    }
  const payload = {
    security: this.loginForm.value.twoFactorAuthCode
  };

  if (this.showTwofactor) { // Support both modal and inline
    this._appMasterService.verifyTwoFactorCode(this.loginForm.value.twoFactorAuthCode).pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(
      (res) => {
        if (this.onSuccess) {
          this.onSuccess.emit();
        } 
      },
      (err) => {
        this._loaderService.hideLoader();
      }
    );
  } else {
    this._appMasterService.adminMaskInfo(this.data?.application_id, payload).pipe(
      takeUntil(this._unsubscribeAll)
    ).subscribe(
      (res) => {
        if (this.dialogRef) {
           this.dialogRef.close(res);
        }
      },
      (err) => {
        this._loaderService.hideLoader();
      }
    );
  }
}


}
